import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useCallback, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../contexts/auth.context';
import { getUrlLogin } from '../services/auth/authService';
import { getTokenFromLocalStorage, tokenHasExpired } from '../services/localStorage/localStorageService';
import { LoginIcon } from './Icons';
function Login() {
    var _a = useAuth(), token = _a.token, setToken = _a.setToken;
    useEffect(function () {
        if (!getTokenFromLocalStorage()) {
            setToken('');
        }
        // eslint-disable-next-line
    }, []);
    var login = useCallback(function () {
        getUrlLogin().then(function (data) {
            window.location.href = data.data.loginUrl;
        });
    }, []);
    return (!token || tokenHasExpired()) ? (LoginIcon(login)) : (_jsx(Redirect, { to: "/" }));
}
export default Login;
